import { Expose, Type } from 'class-transformer';
import { startCase } from 'lodash';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLprRead extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @ExposeRawData()
  public details: any;

  @Expose()
  public geometry: any;

  @Expose()
  public plate: string;

  @Expose()
  @Type(() => Date)
  public eventTimestamp: Date;

  @Expose()
  public confidence: number;

  @Expose()
  public overviewImageUrl: string;

  @Expose()
  public plateImageUrl: string;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  public type: string;

  @Expose()
  @Default('fusus')
  public integratedLprType: string = 'fusus';

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  public getPlate(): string {
    if (this.plate) {
      return this.plate;
    }

    if (this.details.plate) {
      return this.details.plate;
    }

    return '';
  }

  public body(): string {
    let body = '';
    if (startCase(this.details['Vehicle Body Type'])) {
      body = this.details['Vehicle Body Type'];
    }
    if (startCase(this.details['Vehicle Type'])) {
      body = this.details['Vehicle Type'];
    }
    return body;
  }

  public state(): string {
    let state = '';
    if (startCase(this.details['State Name'])) {
      state = this.details['State Name'];
    }
    if (startCase(this.details['Plate State'])) {
      state = this.details['Plate State'];
    }
    return state;
  }

  public make(): string {
    let make = '';
    if (startCase(this.details['Vehicle Make'])) {
      make = this.details['Vehicle Make'];
    }
    return make;
  }
  public model(): string {
    let model = '';
    if (startCase(this.details['Vehicle Make Model'])) {
      model = this.details['Vehicle Make Model'];
    }
    return model;
  }

  get plateImageSrc(): string {
    return this.plateImageUrl;
  }

  get overviewImageSrc(): string {
    return this.overviewImageUrl;
  }

  get googleLatLng(): google.maps.LatLng {
    return new google.maps.LatLng(this.geometry.coordinates[1], this.geometry.coordinates[0]);
  }
}
